/*eslint-disable */
import Vue from 'vue'
import root from '@/_helpers/roots';
import axios from 'axios';
let postForPaymentTrackApiUrl = root.postForPaymentTrackApiUrl.link;
let packageSubscribedTrackApiUrl = root.packageSubscribedTrackApiUrl.link;
let packagesListApiUrl = root.packagesListApiUrl.link;
let packagesInfoApiUrl = root.packagesInfoApiUrl.link;
let planSubscribeApiUrl = root.planSubscribeApiUrl.link;
let applySubscriptionApiUrl = root.applySubscriptionApiUrl.link;
let showPlanInfoByIdApiUrl = root.showPlanInfoByIdApiUrl.link;
let paymentSuccessConfirmationAPIUrl = root.paymentSuccessConfirmationAPIUrl.link;
let paymentHistoryListApiUrl = root.paymentHistoryListApiUrl.link;
let userActivateSubscriptionApiUrl = root.userActivateSubscriptionApiUrl.link;
let getPlanListApiUrl = root.getPlanListApiUrl.link;
let userCancelSubscriptionApiUrl = root.userCancelSubscriptionApiUrl.link;

export default {
  state: {
    getPaymentHistoryListState:{},
    getPackageListState:{},
    getAllPlansListState:{}
  },
  mutations: {
    getPaymentHistoryListMutation(state, value) {
      Vue.set(state, 'getPaymentHistoryListState', value);
    },
    getPackageListMutation(state, value) {
      Vue.set(state, 'getPackageListState', value);
    },
    getAllPlansListMutation(state, value) {
      Vue.set(state, 'getAllPlansListState', value);
    }
  },
  actions: {
    // Get Plans List Function
    userCancelSubscriptionFunc(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(userCancelSubscriptionApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Get Plans List Function
    getAllPlansListFunc(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(getPlanListApiUrl).then(response => {
          context.commit('getAllPlansListMutation', response);
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Payment History Function
    userActivateSubscriptionFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(userActivateSubscriptionApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Payment History Function
    postPaymentHistoryFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(paymentHistoryListApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Payment Success Confirmation Function
    paymentSuccessConfirmationFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(paymentSuccessConfirmationAPIUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Show Plan Info By ID Function
    showPlanInfoByIdFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.get(showPlanInfoByIdApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Post Plan Subscribe Function
    applySubscriptionFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(applySubscriptionApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Post Plan Subscribe Function
    postPlanSubscribeFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(planSubscribeApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Get Packages List Function
    getPackageListFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.get(packagesListApiUrl, payload).then(response => {
            context.commit('getPackageListMutation', response);
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Package Subscribed For Post Function
    packageSubscribedForPostFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.patch(packageSubscribedTrackApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Payment Status For Post Function
    paymentStatusForPostFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(postForPaymentTrackApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Get Payment History Action
    getPaymentHistoryListAction(context, payload) {
        return new Promise((resolve, reject) => {
          axios.get(postForPaymentTrackApiUrl).then(response => {
            context.commit('getPaymentHistoryListMutation', response.data);
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
  },
  getters: {
    getPaymentHistoryListGetters : state => state.getPaymentHistoryListState,
    getPackageListGetters : state => state.getPackageListState,
    getAllPlansListGetters : state => state.getAllPlansListState
  }
}